export function isTestMode() {
    return (window as any)?.testMode;
}
